import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Chip,
} from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import { withRouter } from "react-router-dom";
import { compose } from "recompose";
import parse from "html-react-parser";
import DialogBox from "../../../../../../common/DialogBox";
import QuizEditForm from "./QuizEditForm";

const QuizQuestionTable = ({ classes, list, fetchQuizData }) => {
  const [isOpenQuizEditDialog, setIsOpenQuizEditDialog] = React.useState(false);
  const [selectedQuizItem, setSelectedQuizItem] = React.useState(null);

  // Find the text of the option marked as isCorrect: true
  const getCorrectAnswer = (options) => {
    const correct = options?.find((opt) => opt.isCorrect);
    return correct ? correct.option : "N/A";
  };

  const onQuizEditClick = (item) => {
    setIsOpenQuizEditDialog(true);
    setSelectedQuizItem(item);
  };

  return (
    <div className="formWrapper">
      <h3 className={classes.title} style={{ marginBottom: "16px" }}>
        All Quiz Questions
      </h3>
      <div className={classes.tableContainer}>
        <Table stickyHeader>
          <TableHead>
            <TableRow className={classes.tableHead}>
              <TableCell style={{ minWidth: "60px", textAlign: "center" }}>
                Sr.No
              </TableCell>
              <TableCell style={{ minWidth: "300px" }}>Question</TableCell>
              <TableCell style={{ minWidth: "150px" }}>
                Expected Answer
              </TableCell>
              <TableCell style={{ minWidth: "250px" }}>Options</TableCell>
              <TableCell style={{ minWidth: "500px", textAlign: "center" }}>
                Action
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {list && list.length > 0 ? (
              list.map((item, ind) => (
                <TableRow key={item.id || ind}>
                  <TableCell style={{ textAlign: "center" }}>
                    {ind + 1}
                  </TableCell>

                  <TableCell className={classes.wrapCell}>
                    {/* Maps to "quiz" field in your JSON */}
                    {parse(`${item?.quiz || ""}`)}
                  </TableCell>

                  <TableCell style={{ fontWeight: "bold", color: "#2e7d32" }}>
                    {getCorrectAnswer(item.options)}
                  </TableCell>

                  <TableCell>
                    <div
                      style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}
                    >
                      {item.options?.map((opt) => (
                        <Chip
                          key={opt.id}
                          label={opt.option}
                          size="small"
                          variant="outlined"
                        />
                      ))}
                    </div>
                  </TableCell>

                  <TableCell minWidth="400px" style={{ textAlign: "center" }}>
                    <span
                      style={{
                        cursor: item.isQuizEditable ? "pointer" : "not-allowed",
                        color: item.isQuizEditable ? "#3a6ea5" : "#9e9e9e",
                        pointerEvents: item.isQuizEditable ? "auto" : "none",
                        opacity: item.isQuizEditable ? 1 : 0.6,
                      }}
                      onClick={(e) => {
                        if (!item.isQuizEditable) {
                          e.preventDefault();
                          return;
                        }
                        onQuizEditClick(item);
                      }}
                    >
                      Edit
                    </span>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={5} style={{ textAlign: "center" }}>
                  No questions found.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>

      <DialogBox
        header="Edit Quiz Question"
        open={isOpenQuizEditDialog}
        message={
          <QuizEditForm
            selectedQuizItem={selectedQuizItem}
            onCancel={() => {
              setIsOpenQuizEditDialog(false);
              setSelectedQuizItem(null);
            }}
            onUpdateSuccess={() => {
              setIsOpenQuizEditDialog(false);
              setSelectedQuizItem(null);
              fetchQuizData();
            }}
          />
        }
        dialogContentTextStyle={{ margin: 0 }}
        maxWidth={"md"}
        closeDialog={() => {
          setIsOpenQuizEditDialog(false);
          setSelectedQuizItem(null);
        }}
        disableCloseBtn={false}
      />
    </div>
  );
};

const styles = {
  title: {
    color: "rgb(8, 69, 108)",
  },
  tableContainer: {
    maxHeight: "500px",
    overflowY: "auto",
    border: "1px solid #e0e0e0",
    borderRadius: "4px",
  },
  wrapCell: {
    minWidth: "250px",
    verticalAlign: "top",
  },
  tableHead: {
    "& th": {
      backgroundColor: "#ced4da",
      color: "#495057",
      fontFamily: "Rubik, sans-serif",
      fontSize: "14px",
      fontWeight: "bolder",
      textAlign: "center",
      borderRight: "1px solid #adb5bd",
    },
  },
};

export default compose(
  withStyles(styles, { withTheme: true }),
  withRouter,
)(QuizQuestionTable);
